class Forms {
	constructor() {
		this.forms = $('.wpcf7');
		this.forms.each(function (index, elem) {

			// When clicking a form submit button :
			$(elem).find('.wpcf7-submit').on('click', function () {
				$(elem).addClass('loading');
				setTimeout( () => {
					ScrollTrigger.refresh();
				});
			});

			// When the form validation fails or the mail fails to be sent :
			$(elem).on('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed wpcf7unaccepted', function () {
				$(elem).removeClass('loading');
				setTimeout( () => {
					ScrollTrigger.refresh();
				});
			});

			// When the mail is successfully sent
			$(elem).on('wpcf7mailsent', function () {
				$(elem).removeClass('loading');
				$(elem).addClass('success');

				if (document.body.classList.contains("post-type-archive-conference")) {
					const formContainer = document.querySelector("#formPane");
					const content = formContainer.querySelector(".form-content");
					const success = formContainer.querySelector("#form-success");
					const successBtn = success.querySelector(".download-btn");
					const resetBtn = success.querySelector(".reset-form");

					successBtn.href = atob(success.dataset.file);
					content.classList.add("hidden");
					success.classList.remove("hidden");
					resetBtn.addEventListener("click", (e) => {
						e.preventDefault();
						formContainer.classList.remove("is-active");
						formContainer.querySelector(".wpcf7-response-output").innerHTML = "";
						//add aria-hidden attribute to the .wpcf7-response-output element
						formContainer.querySelector(".wpcf7-response-output").setAttribute("aria-hidden", "true");

						content.classList.remove("hidden");
						success.classList.add("hidden");
						setTimeout( () => {
							ScrollTrigger.refresh();
						});
					});
				} else {
					setTimeout( () => {
						ScrollTrigger.refresh();
					});
				}


			});
		});

		// Managing form inputs and labels focus and filled states :
		this.fields = $('.form-field input:not([type="file"]), .form-field textarea, .form-field select');
		this.fields.each(function (index, elem) {
			let $inputContainer = $(elem).closest('.form-field');
			$(elem).on('focus', function () {
				$inputContainer.addClass('active');
			}).on('blur', function () {
				$inputContainer.removeClass('active');
				if ($(elem).val() === "") {
					$inputContainer.removeClass('filled');
				} else {
					$inputContainer.addClass('filled');
				}
			});
		});

		// Managing input files
		this.fileuploads = $('.form-field--file');
		this.fileuploads.each(function (index, elem) {
			let $inputContainer = $(elem),
				$input = $(elem).find('input[type="file"]'),
				$label = $(this).find( 'label span' ),
				responseValue = $label.html();

			$input.on('click', function () {

				$input.trigger('click');
			});
			$input.on('change', function (e) {
				var fileName = '';
				fileName = e.target.value.split('\\').pop();

				if (fileName) {
					$label.html(fileName);
					$inputContainer.addClass('filled');
				} else {
					$label.html(responseValue);
					$inputContainer.removeClass('filled');
				}
			});

			// Firefox bug fix
			$input
				.on('focus', function () {
					$input.addClass('has-focus');
				})
				.on('blur', function () {
					$input.removeClass('has-focus');
				});
		});
	}
}
